export const OUR_HISTORY_DATA = [
    {
        image: "https://newsoft-ns.com/media/about-us/our-history/2023.webp",
        year: "2023",
        minHeight: 0,
        maxHeight: 2,
        text: [
            "Brought on board 3 new clients.",
            "70% of the team has already composed of Senior Developers.",
            "Expanded the Management team.",
            "Revised the strategy of growth.",
            "Divided the company’s objectives into Step1 (2019-2022), and Step2 (2023-2026)."
        ]
    },
    {
        image: "https://newsoft-ns.com/media/about-us/our-history/2022.webp",
        year: "2022",
        minHeight: 2,
        maxHeight: 4,
        text: [
            "Engaged 4 projects and solidified 10 long-term clients.",
            "Welcomed 13 new employees, increasing the total headcount to 25.",
            "Managed the challenges of the war and kept projects going.",
            "Released an internal Newsoft Inside System for managing employees, checking performance and improving communication between managers and employees."
        ]
    },
    {
        image: "https://newsoft-ns.com/media/about-us/our-history/2021.webp",
        year: "2021",
        minHeight: 4,
        maxHeight: 6,
        text: [
            "Engaged 4 clients.",
            "Expanded Newsoft’s workforce to a team of 20 people.",
            "Successfully navigated pandemic challenges, kept projects going.",
            "Developed the company culture, and organized team-building events, tournaments, entertainment, and trips to the Carpathians.",
            "Started working on the Newsoft Inside System."
        ]
    },
    {
        image: "https://newsoft-ns.com/media/about-us/our-history/2020.webp",
        year: "2020",
        minHeight: 6,
        maxHeight: 8,
        text: [
            "Successfully engaged 5 sustainable clients.",
            "Added 5 Developers to the current team.",
            "Moved to a new and spacious office.",
            "Continue following principles: Win-Win cooperation & Creating Value."
        ]
    },
    {
        image: "https://newsoft-ns.com/media/about-us/our-history/2019.webp",
        year: "2019",
        minHeight: 8,
        maxHeight: 50,
        text: [
            "Founded Newsoft company.",
            "Established the first office.",
            "Completed a travel project.",
            "Launched the Newsoft website.",
            "Successfully engaged two long-term clients.",
            "Entered the exploratory phase and formulated the company’s mission."
        ]
    }
]
